import i18n from 'Pods/Shared/I18n'

import twentyOff from 'images/coupons/20off.webp'
import fiftyOff from 'images/coupons/50off.webp'
import seventyOff from 'images/coupons/70off.webp'
import freeModels from 'images/coupons/free3d.webp'

export const couponsList = [
  {
    title: '$10 OFF',
    description: i18n.t('coupons.couponsList.discount', { ns: 'rails' }),
    code: 'UNLOCKCGT10',
    imgSrc: twentyOff,
    url: '/3d-models?sale_off=1 ',
  },
  {
    title: 'Free 3D Models',
    description: i18n.t('coupons.couponsList.freeModels', { ns: 'rails' }),
    imgSrc: freeModels,
    url: '/3d-models?free=1',
  },
  {
    title: '50% OFF',
    description: i18n.t('coupons.couponsList.discounts', { ns: 'rails' }),
    imgSrc: fiftyOff,
    url: '/3d-models?sale_off=1',
  },
  {
    title: '70% OFF',
    description: i18n.t('coupons.couponsList.discounts', { ns: 'rails' }),
    imgSrc: seventyOff,
    url: '/3d-models?sale_off=1',
  },
]
